import React from 'react';
import ABSFieldDesc from './Desc';
import ABSFieldError from './Error';
import ABSFieldTitle from './Title';
import ABSFieldCustom from './Custom';
import classnames from 'classnames';
import { IABSFieldProps } from './interface';
import './index.less';

const ABSField: React.FC<IABSFieldProps> = props => {
  const { className, removeMarginBottom, isVertical } = props;
  const clazz = classnames('abs-field', { 'remove-margin-bottom': removeMarginBottom }, { 'abs-field-vertical': isVertical }, className);

  const renderTitle = () => {
    const { title, required, labelWidth, removePaddingLeft, titleClassName } = props;
    const titleProps = {
      title,
      required,
      labelWidth,
      removePaddingLeft,
      isVertical
    };
    return <ABSFieldTitle className={titleClassName} {...titleProps} />;
  };

  const renderContent = () => {
    const { children, contentClassName, contentWidth, result, desc } = props;
    const contentClass = classnames(
      'abs-field-content',
      { 'has-error': !result.pass },
      contentClassName
    );
    const style = contentWidth ? { style: { width: contentWidth, flexGrow: 0 }} : {};
    return (
      <div className={contentClass} {...style}>
        {children}
        <ABSFieldError result={result} />
        <ABSFieldDesc desc={desc} />
      </div>
    );
  };

  return (
    <div className={clazz}>
      {renderTitle()}
      {renderContent()}
    </div>
  );
};

export { IABSFieldProps, ABSFieldDesc, ABSFieldError, ABSFieldTitle, ABSFieldCustom };

export default ABSField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSField/index.tsx